import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar'; 
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AppService } from 'src/app/app.service';
import { HostService } from 'src/app/services/host.service';

@Component({
  selector: 'app-cart',
  templateUrl: './switch.component.html',
  styleUrls: ['./switch.component.scss']
})
export class SwitchComponent implements OnInit {
  public total:any[] = []; 
  public cartItemCount:any[] = [];
  public cartItemCountTotal:number = 0; 
  public currentTotalCartCount:number = 0;
  public bgImage: any;
  
  constructor(
    public appService:AppService, 
    public snackBar: MatSnackBar,
    private sanitizer: DomSanitizer,
    public hostService:HostService,
    public router: Router,
    private toastr: ToastrService,
  ) { }

  ngOnInit(): void {  
    this.bgImage = this.sanitizer.bypassSecurityTrustStyle("url("+this.hostService.getHttpsImage()+"images/others/switch.jpg");
    
  }

  public switchAccountUser(role:string){
    const storageAuth = localStorage.getItem("user");
    if (storageAuth) {
      let User = JSON.parse(storageAuth);
      User.roleApp = role;
      localStorage.setItem('user', JSON.stringify(User));
      this.toastr.success("connection réussie avec succès ");
      this.router.navigateByUrl("/compte-utilisateur");
        }
    else{
      this.snackBar.open("Vous devez vous connecter afin de pouvoir changer le type de compte", "Fermer", {
        duration: 6000,
        verticalPosition: 'top',
        panelClass: ['snackbar-danger']
      });
    }
  }


}
